import { render } from "./OrdersWeek.vue?vue&type=template&id=1b2f5517"
import script from "./OrdersWeek.vue?vue&type=script&lang=js"
export * from "./OrdersWeek.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__